// Typelizer digest d1cfa54ee78b018c0b9931f98f9d8b08
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
export { default as adminUsers } from './Admin/UsersController'
export { default as adminWeather } from './Admin/WeatherController'
export { default as alerts } from './AlertsController'
export { default as currentGroups } from './CurrentGroupsController'
export { default as dailyEntries } from './DailyEntriesController'
export { default as dashboard } from './DashboardController'
export { default as digestUnsubscribes } from './DigestUnsubscribesController'
export { default as farms } from './FarmsController'
export { default as fieldDays } from './FieldDaysController'
export { default as fieldGroupDays } from './FieldGroupDaysController'
export { default as fieldGroups } from './FieldGroupsController'
export { default as fields } from './FieldsController'
export { default as groups } from './GroupsController'
export { default as magicLinks } from './MagicLinksController'
export { default as map } from './MapController'
export { default as memberships } from './MembershipsController'
export { default as pages } from './PagesController'
export { default as pivotIrrigations } from './PivotIrrigationsController'
export { default as pivots } from './PivotsController'
export { default as plantings } from './PlantingsController'
export { default as quickSetups } from './QuickSetupsController'
export { default as seasonCopies } from './SeasonCopiesController'
export { default as settings } from './SettingsController'
export { default as setup } from './SetupController'
export { default as usersConfirmations } from './Users/ConfirmationsController'
export { default as usersPasswords } from './Users/PasswordsController'
export { default as usersRegistrations } from './Users/RegistrationsController'
export { default as usersSessions } from './Users/SessionsController'

import _pages from './PagesController'
import _adminUsers from './Admin/UsersController'
import _usersRegistrations from './Users/RegistrationsController'
import _usersConfirmations from './Users/ConfirmationsController'
import _currentGroups from './CurrentGroupsController'
import _dailyEntries from './DailyEntriesController'
import _dashboard from './DashboardController'
import _usersSessions from './Users/SessionsController'
import _digestUnsubscribes from './DigestUnsubscribesController'
import _pivots from './PivotsController'
import _usersPasswords from './Users/PasswordsController'
import _plantings from './PlantingsController'
import _farms from './FarmsController'
import _fields from './FieldsController'
import _fieldDays from './FieldDaysController'
import _fieldGroups from './FieldGroupsController'
import _fieldGroupDays from './FieldGroupDaysController'
import _groups from './GroupsController'
import _magicLinks from './MagicLinksController'
import _memberships from './MembershipsController'
import _quickSetups from './QuickSetupsController'
import _pivotIrrigations from './PivotIrrigationsController'
import _adminWeather from './Admin/WeatherController'
import _seasonCopies from './SeasonCopiesController'
import _alerts from './AlertsController'

export const about = _pages.about
export const adminUser = _adminUsers.show
export const cancelUserRegistration = _usersRegistrations.cancel
export const confirmUserConfirmation = _usersConfirmations.confirm
export const currentGroup = _currentGroups.update
export const dailyEntry = _dailyEntries.show
export const dashboardRoot = _dashboard.show
export const destroyUserSession = _usersSessions.destroy
export const digestAdminUser = _adminUsers.digest
export const digestUnsubscribe = _digestUnsubscribes.show
export const editPivot = _pivots.edit
export const editUserPassword = _usersPasswords.edit
export const editUserRegistration = _usersRegistrations.edit
export const exportPlanting = _plantings.export
export const farm = _farms.update
export const field = _fields.show
export const fieldDay = _fieldDays.update
export const fieldGroup = _fieldGroups.show
export const fieldGroupDay = _fieldGroupDays.update
export const group = _groups.show
export const magicLink = _magicLinks.show
export const membership = _memberships.update
export const newPivot = _pivots.new
export const newQuickSetup = _quickSetups.new
export const newUserConfirmation = _usersConfirmations.new
export const newUserPassword = _usersPasswords.new
export const newUserRegistration = _usersRegistrations.new
export const newUserSession = _usersSessions.new
export const pivot = _pivots.show
export const pivotIrrigation = _pivotIrrigations.update
export const planting = _plantings.update
export const quickSetup = _quickSetups.create
export const redeemMagicLink = _magicLinks.redeem
export const refreshAdminWeather = _adminWeather.refresh
export const root = _pages.home
export const seasonCopy = _seasonCopies.create
export const signInCode = _magicLinks.code
export const testEmailAlerts = _alerts.testEmail
export const userConfirmation = _usersConfirmations.show
export const userPassword = _usersPasswords.update
export const userRegistration = _usersRegistrations.update
export const userSession = _usersSessions.create
